import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import Loader from "../../../components/Loader";
import { useQuery } from "@tanstack/react-query";
import Table from "../../../components/Table";
import { Link } from "react-router-dom";
import { EquipementscolumnsBarco } from "../../../components/headerContent";
import NumberCard from "../../../components/Card/NumberCard";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function EquipementBarco() {
  const { apiUrl, user } = useContext(AuthContext);
  const { t, i18n } = useTranslation();
  const [filteredData, setFilteredData] = useState([]);

  const getEquipementsBarco = async () => {
    const res = await axios.get(`${apiUrl}barco/devices`, {
      withCredentials: true,
    });
    return res.data;
  };

  const EquipementsBarco = useQuery({
    queryKey: ["EquipementsBarco"],
    queryFn: getEquipementsBarco
  });

  useEffect(() => {
    if (!EquipementsBarco.isFetching && EquipementsBarco.data && EquipementsBarco.data.devices.length > 0) {
      setFilteredData(EquipementsBarco.data.devices);
    }
  }, [EquipementsBarco]);

  if (!EquipementsBarco.isLoading && EquipementsBarco.data && EquipementsBarco.data.length === 0 || !EquipementsBarco.isLoading && !EquipementsBarco.data) {
    return (
      <div className="ecp-container">
        <div className="ecp-container-content-error">
          <div className="error-container">
            <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
            <div className="error-container-text">
              <h1 className="page-title">
                {t("Aucun équipement disponible")}
              </h1>
              <p className="page-link_home">
                <Link to="/"> {t("Revenir à l'accueil")}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ecp-container">
      <div className="ecp-container-content">
        {!EquipementsBarco.isLoading && !EquipementsBarco.isFetching ? (
          <>
            <div className="ecp-container-content-header">
              <div className="ecp-container-content-header-title">
                <div className="page-title page-logo">
                  <img src="../assets/barco.png" alt="Logo de Barco" />
                  <h1 className="page-title">{t("Equipements")} Barco</h1>
                </div>
              </div>
            </div>
            <section className="page-section">
              <NumberCard
                title={`${t("Nombre d'équipements disponibles")}`}
                number={
                  filteredData.length
                }
                logo={faCircleCheck}
                color={"#AEC353"}
                stylesIcons={"logo-certificats"}
              />
            </section>
            <div className='cato-content-table'>
              <Table
                tableData={
                  filteredData
                }
                tableColumns={EquipementscolumnsBarco}
                sites={filteredData}
                holding={user.entrepriseId}
              />
            </div>
          </>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}